import React from "react";
import { useTranslation } from "react-i18next";
import LoadingIndicator from "react-loading-indicator";

import * as SC from "./CampaignCreateNavigation.styled";
import useCampaignCreationSteps from "./hooks/useCampaignCreationSteps";
import { Tooltip } from "../../Previews/Components";
import useDisableCampaignCreation from "./hooks/useDisableCampaignCreation";
import {
  CampaignCreationStore,
  PreviewStore,
  QualificationQuestionsStore,
  withRefluxStore
} from "../../../../Stores";
import { BOOKING_STEPS } from "../utils/constants";
import useIntercomStyles from "./hooks/useIntercomStyles";
import logger from "../../../../utils/LoggerFrontend";

const CampaignCreateNavigation = ({
  disableDraft,
  adErrors,
  draftCampaignId = null,
  onSaveDraft,
  onNextStep,
  isLoadingBooking,
  disabledBooking,
  campaignGoal,
  // Store
  userProfile,
  bookingStyle,
  lifeTimeBudget,
  campaignDuration,
  currentStep,
  selectedChatbotQuestion
}) => {
  useIntercomStyles();
  const { t } = useTranslation();
  const { redirectBack, redirectNext, continueLabel } = useCampaignCreationSteps();
  const { STEP_BASE_DATA } = BOOKING_STEPS;
  const { isDisabled, disabledMessage } = useDisableCampaignCreation({
    bookingStyle,
    lifeTimeBudget,
    campaignDuration,
    currentStep,
    selectedChatbotQuestion,
    disabledBooking,
    adErrors,
    language: userProfile?.language
  });

  const hideQualificationQuestions = campaignGoal === "traffic";

  logger.debug("CampaignCreateNavigation", "show navigation", {
    campaignGoal,
    currentStep,
    hideQualificationQuestions
  });

  return (
    <SC.NavigationWrapper>
      <SC.ActionButtonsWrapper>
        {currentStep !== STEP_BASE_DATA && (
          <SC.BackButton onClick={() => redirectBack(currentStep, hideQualificationQuestions)}>
            {t("Back")}
          </SC.BackButton>
        )}
      </SC.ActionButtonsWrapper>
      <SC.ActionButtonsWrapper>
        {currentStep !== STEP_BASE_DATA && (
          <SC.DrafButton onClick={onSaveDraft} disabled={disableDraft}>
            {draftCampaignId ? t("Update draft") : t("Save as draft")}
          </SC.DrafButton>
        )}
        <div data-tip data-for="next-button">
          {isDisabled && disabledMessage && (
            <Tooltip
              id="next-button"
              effect="solid"
              backgroundColor="#1C1928"
              offset={{ right: -80, top: 10 }}
              noArrow
            >
              <span>{disabledMessage}</span>
            </Tooltip>
          )}
          <SC.ContinueButton
            onClick={(e) => redirectNext(e, currentStep, onNextStep)}
            disabled={isDisabled}
            id="next-button-booking"
          >
            {isLoadingBooking ? <LoadingIndicator /> : continueLabel(currentStep)}
          </SC.ContinueButton>
        </div>
      </SC.ActionButtonsWrapper>
    </SC.NavigationWrapper>
  );
};

export default withRefluxStore(
  CampaignCreateNavigation,
  [CampaignCreationStore, QualificationQuestionsStore, PreviewStore],
  [
    "bookingStyle",
    "lifeTimeBudget",
    "campaignDuration",
    "currentStep",
    "selectedChatbotQuestion",
    "userProfile"
  ]
);
